import type React from "react"
import { useState } from "react"
import styled from "styled-components"
import { Icon } from "../Icon"

const MenuWrapper = styled.div`
  position: relative;
`

const Wrapper = styled.div`
  position: absolute;
  display: flex;

  flex-direction: column;
  background: white;
  z-index: 100;
  border-radius: ${(props) => props.theme.sizes.defaultBorderRadius};
  box-shadow: ${(props) => props.theme.shadow.primary};

  transform: translateY(50px);
`

const MenuItemWrapper = styled.div`
  padding: 14px 16px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;

  :hover {
    text-decoration: underline;
    cursor: pointer;
    color: ${(props) => props.theme.colors.primary40};
  }
`

interface IconWrapperProps {
  active?: boolean
}

const IconWrapper = styled.div<IconWrapperProps>`
  padding: 12px;
  border-radius: ${(props) => props.theme.sizes.defaultBorderRadius};
  ${(props) =>
    props.active &&
    `    color: ${props.theme.colors.primary10};
    background: ${props.theme.colors.primary95};`}

  :hover {
    cursor: pointer;
  }
`

interface MenuItem {
  title: string
  handleClick: () => void
}

export interface MenuProps {
  menuItems: MenuItem[]
}

export const Menu: React.CFC<MenuProps> = ({ menuItems }) => {
  const [open, setOpen] = useState<boolean>(false)
  return (
    <MenuWrapper>
      {open && (
        <Wrapper>
          {menuItems.map((menuItem) => {
            return (
              <MenuItemWrapper
                key={`menuItem-${menuItem.title}`}
                onClick={() => {
                  menuItem.handleClick()
                  setOpen(!open)
                }}
              >
                {menuItem.title}
              </MenuItemWrapper>
            )
          })}
        </Wrapper>
      )}
      <IconWrapper active={open} onClick={() => setOpen(!open)}>
        <Icon size="18px" icon="ellipsis-v" />
      </IconWrapper>
    </MenuWrapper>
  )
}
